var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 249.78 204.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 215.09,
    y1: 205.74,
    x2: 215.09,
    y2: 158.82,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 205.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4dc",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 149.44,
    y1: 121.05,
    x2: 153.72,
    y2: 116.91,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 205.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d9aa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9aa9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 131.34,
    y1: 132.66,
    x2: 135.55,
    y2: 128.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 163.67,
    y1: 147.3,
    x2: 175.43,
    y2: 192.12,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 145.93,
    y1: 132.23,
    x2: 165.21,
    y2: 161.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 166.01,
    y1: 163.66,
    x2: 162.21,
    y2: 157.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 205.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4dc",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 68.72,
    y1: 14.64,
    x2: 6.92,
    y2: 28.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 75.06,
    y1: 26.45,
    x2: 77.16,
    y2: 43.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 101.6,
    y1: 74.21,
    x2: 78.59,
    y2: 36.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 105.72,
    y1: 80.26,
    x2: 101.92,
    y2: 73.93,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 93.81,
    y1: 158.48,
    x2: 111.66,
    y2: 134.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 205.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 88.42,
    y1: 138.34,
    x2: 99.85,
    y2: 123.06,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 75.26,
    y1: 126,
    x2: 91.22,
    y2: 104.66,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 136.17,
    y1: 77.32,
    x2: 153.31,
    y2: 54.41,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 150.83,
    y1: 86.96,
    x2: 162.49,
    y2: 71.37,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 161.88,
    y1: 104.32,
    x2: 181.04,
    y2: 78.69,
    xlinkHref: "#linear-gradient-11"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "misc-system-new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.78,18.65c8.95-8.94,24.87-20.74,33.14-2.29,1.66,3.91,3,28.28,20,30.49,4.84.63,12-2.78,9.17-6.75-.63-.86-1.62-1.3-3.81-.71a14.84,14.84,0,0,1-7.06-.25A12.41,12.41,0,0,1,233,35.77c-2.36-2.52-3.85-7.06-4.62-11.42-1-5.9-5-32.92-31.8-21.62a42.94,42.94,0,0,0-16.16,11.52C181.91,14,185.91,15.65,186.78,18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153,77.88,145.56,90a2.73,2.73,0,0,0,.83,3.77l.25.17a2.73,2.73,0,0,0,3.77-.83L158,80.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.05,66.33l-7.68,12a2.73,2.73,0,0,0,.76,3.78l.25.17a2.72,2.72,0,0,0,3.78-.76l7.77-12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.34,24.08l4.71-7.34a5.45,5.45,0,0,1,7.54-1.65l1,.63a5.45,5.45,0,0,1,1.65,7.53l-4.72,7.35a5.13,5.13,0,0,1-.44.6l3.31,2.13A5.45,5.45,0,0,1,186,40.86l-6.52,9.67L152.32,33.1l6.59-9.62a5.46,5.46,0,0,1,7.54-1.65L171,24.74A4.73,4.73,0,0,1,171.34,24.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147,38.45,133.75,59a5.44,5.44,0,0,0,1.65,7.53l21.37,13.72a5.45,5.45,0,0,0,7.53-1.65L177.4,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.2,33.49l-.1.15a3.64,3.64,0,0,0,1.1,5l29.93,19.21a3.64,3.64,0,0,0,5-1.09l.1-.16a3.64,3.64,0,0,0-1.1-5L151.22,32.39A3.62,3.62,0,0,0,146.2,33.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3.82,165.29c6.16-1.8,12.24-.16,16.39,9.1C22,178.65,23.13,206.73,45,204.27a26.31,26.31,0,0,0,12.85-5.35c5.65-4.27,13.41-11.45,16.46-18.69a8.31,8.31,0,0,1-5-2.82c-4.92,6.85-15.26,19.24-26.32,20.07a12.49,12.49,0,0,1-12.21-7.59,30.7,30.7,0,0,1-2.14-7.51c-.79-5.16-4-26.39-22.64-24.19-2.67.31-5.2,1.7-5.84,4.31C-.34,164.62.11,166.64,3.82,165.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M73.37,164.43l-4.25,6.79a5.44,5.44,0,0,0,1.65,7.53l1,.63a5.45,5.45,0,0,0,7.54-1.65L83.57,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M75.37,139.36,86.75,121.9,117,141.45,105.93,159A5.46,5.46,0,0,1,99.2,161l-6.14,9.57a5.46,5.46,0,0,1-7.54,1.64l-14-9a5.44,5.44,0,0,1-1.65-7.53L76,146.09A5.47,5.47,0,0,1,75.37,139.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M85.9,116.89l-.09.15a3.64,3.64,0,0,0,1.09,5l29.94,19.2a3.64,3.64,0,0,0,5-1.09L122,140a3.62,3.62,0,0,0-1.09-5L90.93,115.79A3.64,3.64,0,0,0,85.9,116.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M110.14,72.26a2.54,2.54,0,0,1-3.42-.82L93.06,50.92a2.55,2.55,0,0,1,.71-3.61l1.68-1a2.55,2.55,0,0,1,3.53,1l12,21.56a2.53,2.53,0,0,1-.82,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.09,80.93a1.71,1.71,0,0,1-.47.42,1.55,1.55,0,0,1-.59.21,1.61,1.61,0,0,1-.62,0,1.5,1.5,0,0,1-.57-.27l-13-9.38a1.77,1.77,0,0,1-.7-1.12,1.74,1.74,0,0,1,.29-1.29l.77-1a1.74,1.74,0,0,1,.5-.44,1.6,1.6,0,0,1,.63-.2,1.64,1.64,0,0,1,.66.07,1.55,1.55,0,0,1,.57.33l12.26,10.43a1.73,1.73,0,0,1,.3,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M102.18,91.9c-.05,1.37-1.45,2.4-3.17,2.33L68.49,93c-1.82-.07-3.3-1.34-3.25-2.8l.08-2c.05-1.45,1.61-2.51,3.43-2.31L99.2,89.11C100.91,89.3,102.23,90.52,102.18,91.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M140.75,125.17a2.56,2.56,0,0,1,1.88.21,2.51,2.51,0,0,1,1.21,1.46l8,23.33a2.55,2.55,0,0,1-1.61,3.3l-1.89.57a2.53,2.53,0,0,1-3.15-1.87l-6.08-23.9a2.54,2.54,0,0,1,.21-1.89A2.57,2.57,0,0,1,140.75,125.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M150.75,118.84a1.55,1.55,0,0,1,.56-.28,1.44,1.44,0,0,1,.62,0,1.62,1.62,0,0,1,.6.19,1.69,1.69,0,0,1,.48.41l10.2,12.39a1.75,1.75,0,0,1-.22,2.44l-1,.81a1.57,1.57,0,0,1-.59.3,1.83,1.83,0,0,1-.66,0,1.74,1.74,0,0,1-.62-.24,1.87,1.87,0,0,1-.47-.46l-9.18-13.22a1.73,1.73,0,0,1,.3-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M153.46,108.22c.4-1.31,2-2,3.66-1.44l29.2,9c1.74.54,2.84,2.15,2.42,3.54l-.59,1.95c-.43,1.39-2.21,2-3.91,1.36l-28.61-10.93A3,3,0,0,1,153.46,108.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.2c91ae5c1dc2a9e84ea2d50e5b9518e5.svg";
export { ForwardRef as ReactComponent };